import { SxProps, Theme } from "@mui/material";
import {
  assessmentFlowContainerStyle,
  assessmentPhoneLandscapeMedia,
  assessmentShortViewportMedia,
} from "../assessment-layout-styles";

export const containerStyle: SxProps<Theme> = assessmentFlowContainerStyle;

export const headerBoxStyle: SxProps<Theme> = {
  px: { xs: 2, sm: 4, md: 4 },
  pb: { xs: 1, sm: 2, md: 3 },
  pt: 0,
  position: "relative",
  flexShrink: 0,
  [assessmentPhoneLandscapeMedia]: {
    px: 2,
    pb: 0.5,
    pt: 0,
  },
  [assessmentShortViewportMedia]: {
    px: 1.5,
    pb: 0.5,
    pt: 0,
  },
};

export const closeButtonStyle: SxProps<Theme> = (theme) => ({
  position: "absolute",
  right: 20,
  top: 25,
  cursor: "pointer",
  color: theme.palette.quizPopap.quizeCross,
});

export const contentBoxStyle: SxProps<Theme> = {
  flex: "1 1 0",
  minHeight: { sm: 240, md: 320 },
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  px: { xs: 2, sm: 4, md: 6 },
  pb: 2,
  [assessmentShortViewportMedia]: {
    px: 1.5,
    pb: 1,
    minHeight: 120,
  },
};

export const footerBoxStyle: SxProps<Theme> = (theme) => ({
  flexShrink: 0,
  p: { xs: 1, sm: 1.25, md: 1.5, lg: 2 },
  textAlign: "right",
  borderTop: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  [assessmentPhoneLandscapeMedia]: {
    p: "6px 12px",
  },
  [assessmentShortViewportMedia]: {
    p: "6px 10px",
  },
});

export const footerActionsStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "flex-end" },
  justifyContent: "space-between",
  gap: { xs: 1.5, sm: 2 },
};

export const managerBypassBoxStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: { xs: "stretch", sm: "flex-start" },
  gap: 0.75,
  maxWidth: { xs: "100%", sm: "55%" },
  textAlign: "left",
};

export const managerBypassHintStyle: SxProps<Theme> = {
  color: "text.secondary",
  fontSize: { xs: "12px", sm: "13px" },
  lineHeight: 1.4,
};

export const managerBypassWaitingHintStyle: SxProps<Theme> = {
  color: "#06B6D4",
  textAlign: "center",
  fontWeight: 700,
  fontSize: { xs: "15px", sm: "16px" },
  lineHeight: 1.4,
};

export const managerBypassWaitingBoxStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.5,
  mt: 1.5,
  mb: 2,
  px: 1,
};

export const managerBypassButtonStyle = (
  disabled: boolean
): SxProps<Theme> => ({
  backgroundColor: disabled ? "#9ED9E2" : "#06B6D4",
  color: "#fff",
  border: "none",
  borderRadius: "9999px",
  textTransform: "none",
  fontWeight: 600,
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1, sm: 1.25 },
  fontSize: { xs: "13px", sm: "14px" },
  minHeight: { xs: 40, sm: 44 },
  boxShadow: "none",
  alignSelf: { xs: "stretch", sm: "flex-start" },
  "&:hover:not(.Mui-disabled)": {
    backgroundColor: "#06B6D4",
    opacity: 0.9,
  },
  "&.Mui-disabled": {
    color: "#ffffff",
    backgroundColor: "#9ED9E2",
    opacity: 1,
  },
  "&.Mui-disabled:hover": {
    backgroundColor: "#9ED9E2",
    opacity: 1,
  },
});

export const buttonStyle = (
  _theme: Theme,
  disabled: boolean
): SxProps<Theme> => ({
  backgroundColor: disabled ? "#9ED9E2" : "#06B6D4",
  color: "#fff",
  borderRadius: "9999px",
  textTransform: "none",
  fontWeight: 600,
  px: { xs: 2, sm: 3, md: 3 },
  py: { xs: 1, sm: 1.5, md: 1.5 },
  fontSize: { xs: "14px", sm: "16px", md: "16px" },
  minHeight: { xs: 40, sm: 44, md: 44 },
  boxShadow: "none",
  "&:hover:not(.Mui-disabled)": {
    backgroundColor: "#06B6D4",
    opacity: 0.9,
  },
  "&.Mui-disabled": {
    color: "#ffffff",
    backgroundColor: "#9ED9E2",
    opacity: 1,
  },
  "&.Mui-disabled:hover": {
    backgroundColor: "#9ED9E2",
    opacity: 1,
  },
});

export const iconBoxStyle: SxProps<Theme> = {
  ml: { xs: 1, sm: 2, md: 2 },
  width: { xs: 24, sm: 32, md: 32 },
  height: { xs: 24, sm: 32, md: 32 },
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    width: { xs: "24px", sm: "36px", md: "36px" },
    height: { xs: "24px", sm: "36px", md: "36px" },
  },
};
